import { createAuthClient } from "better-auth/react";
import { organizationClient } from "better-auth/client/plugins";

// Better-Auth React client. Same-origin (vite dev proxies /v1/auth/* to
// wrangler dev), so cookies are first-party and SameSite=Lax works.
export const authClient = createAuthClient({
  baseURL: window.location.origin,
  basePath: "/v1/auth",
  plugins: [organizationClient()],
  fetchOptions: {
    // Dead-session guard, mirroring http() in api.ts (8d152e5): these client
    // calls (organization.list/setActive, session refresh) bypass http(), so
    // without this a 401 here leaves the cookie-cached "logged in" UI running
    // — the loop shape that produced the Jul-2026 30M-request flood. A hard
    // navigation resets the Better-Auth store and parks the tab on /login.
    onError(ctx) {
      if (ctx.response?.status === 401 && !location.pathname.startsWith("/login")) {
        const next = location.pathname + location.search;
        window.location.assign(`/login?next=${encodeURIComponent(next)}`);
      }
    },
  },
});

export const { useSession, signIn, signUp, signOut, organization } = authClient;
